<template lang="pug">
  .document-thumbnail( :class="'type-' + file_type() + ' ' + is_locked_class()")
    p {{ has(doc.name) }}
    strong {{ has(doc.file_name) }}
    Button(v-if="is_locked() == false" v-bind:type="'secondary tiny-width rounded-small'" @click.native="download(doc)" ) Download
</template>

<script>
  import DocumentService from '@/services/document'
  import Axios from 'axios';
  import { saveAs } from 'file-saver';
  import mime from 'mime';

  export default {
    props: ['type','doc','userPremium'],
    methods: {
      is_locked: function() {

        // free documents overwrite
        if(this.doc.requires_premium == false)
          return false;

        // console.log(`requires premium: ${this.doc.requires_premium}, userPremium: ${this.userPremium}`)

        if(this.doc.requires_premium == true && this.userPremium == true)
          return false;

        if(this.doc.assigned != true)
          return true;
          
        return false;
      },
      is_locked_class() {
        return (this.is_locked() == true ? 'locked' : 'unlocked')
      },
      has: function(value) {
        if(value !== undefined)
          return value;
        return 'undefined.';
      },
      file_type: function() {
        return this.doc.file_name.substr(this.doc.file_name.lastIndexOf('.') + 1)
      },
      download: async function(dl) {
        let item = this;
        const BASE_URL = process.env.VUE_APP_HOST || 'http://localhost:3333';
        const { value: accept } = await this.$swal.fire({
          title: 'Download Document',
          input: 'checkbox',
          inputValue: 0,
          inputPlaceholder:
            'By downloading this document, I agree with PositivePeopleHR\'s Terms & Conditions.',
          confirmButtonText:
            'Download<i class="fa fa-arrow-right"></i>',
          inputValidator: (result) => {
            return !result && 'You need to agree with Terms & Conditions before proceeding.'
          }
        })

        if (accept) {
          Axios({
            url: BASE_URL + '/document/download/' + dl.id,
            method: 'GET',
            responseType: 'blob'
          })
            .then(response => {
              this.$swal.fire({
                icon: 'success',
                title: 'Downloading..',
                html: '<p>Your document should download shortly.</p><br><hr><small>Make sure pop-ups are allowed!.</small>'
              })
              console.log(response.status);
              let type = response.data.type;
              let extension = mime.getExtension(type);
              let blob = new Blob([response.data])
              saveAs(blob, dl.name + "." + extension);
            })
            .catch(err => {
              if(err.response) {
                var reader = new FileReader();
                reader.onload = function() {
                  const ERROR_MESSAGE = item.$i18n.t('error_messages.' + reader.result);
                  item.$swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: ERROR_MESSAGE
                  })
                }
                reader.readAsText(err.response.data);
              }
            })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .document-thumbnail {
    min-height:102px;
    float:left;
    padding:12px;
    padding-right: 70px;
    margin-top:10px;
    margin-right:8px;
    background-repeat: no-repeat;
    background-size:24px;
    background-position: bottom 11px right 12px;
    border-radius:8px;
    border:1px solid #888;
    transition: background-color 300ms ease, color 300ms ease;

    background-image: url('~@/assets/images/pdf.svg');
    &.type-docx,
    &.type-doc {
      background-image: url('~@/assets/images/docx.svg');
    }

    &.locked {
      &:hover {
        background-color: #ff6262;
        border-color: #ff6262;
        color:#fff;
        cursor:pointer;
        background-image: url('~@/assets/images/pdf-white.svg');
        &.type-docx,&.type-doc {
          background-image: url('~@/assets/images/docx-white.svg');
        }
        ::after {
          background-image:url('~@/assets/images/lock-document-white.svg');
        }
      }
    }
    &.locked,&.unlocked {
      position:relative;
      ::after {
        background-image:url('~@/assets/images/lock-document.svg');
        width:24px;
        height:24px;
        background-size:contain;
        background-repeat:no-repeat;
        content: " ";
        position:absolute;
        bottom:12px;
        right:39px;
      }
    }
    &.unlocked {
      ::after {
        width:20px;
        height:20px;
        bottom: 13px;
        right:42px;
        background-image:url('~@/assets/images/unlock-document.svg');
      }
    }
    p {
      font-size:11px;
    }
  }
</style>